export class InsuredTripCancelRequest {
  cancelDate: string;
  note: string;
}
